import { createStore } from 'vuex'
import axios from 'axios';

let userLanguage = window.navigator.userLanguage || window.navigator.language;
userLanguage.includes("nl") ? userLanguage = "nl" : userLanguage = "en";
const lang = userLanguage;
// console.log("taal: ", lang);

export default createStore({
	state: {
		content: [],
		language: lang
	},
	mutations: {
		SAVE_DATA (state, data) {
			state.content = data.data.data;
		}, 

		switchLanguage (state) {
			if (state.language === "nl") {
				state.language = "en"
			}
			else {
				state.language = "nl"
			}
		}
	},
	getters: {
	},
	actions: {
		loadContent({ commit, state }) {
			return new Promise((resolve, reject) => { 
				axios
					.get(process.env.VUE_APP_API)
					.then(result => {
						// console.log("binnengehaald: ", result);
						commit("SAVE_DATA", result);
						resolve();
					})
					.catch(error => {
						reject();
						throw new Error(`API ${error}`);
					});
			})
		},    
	},
	modules: {

	}
})
